// Section headings and the standing legal paragraph for the job detail template.
// The list items under each heading come from Hygraph per role; only the chrome
// around them lives in code.
export const SECTION_HEADINGS = {
    responsibilities: "What you’ll do",
    qualifications: "What you bring",
    niceToHave: "Nice to have",
    keyDetails: "Key Details",
    whyJoinUs: "Why join us",
};

export const equalOpportunity = {
    heading: "Equal opportunity at PMG",
    body: "PMG is an equal opportunity employer. We welcome applicants of every background and do not discriminate based on race, color, religion, sex, gender identity or expression, sexual orientation, national origin, age, disability, veteran status, or any other protected characteristic.",
};

// Key Details is authored in Hygraph. When a role leaves it empty it falls back
// to the At a glance facts, so the section is never a bare heading and the two
// places showing the same facts stay in step by default.
export const keyDetails = (role) =>
    role.keyDetails && role.keyDetails.length ? role.keyDetails : derivedKeyDetails(role);

const derivedKeyDetails = (role) => [
    `Location: ${role.location}`,
    `Work model: ${role.workModel}`,
    `Employment: ${role.employment}`,
    `Team: ${role.teamLabel}`,
];

export const glanceFacts = (role) => [
    { id: "location", icon: "mapPin", label: "LOCATION", value: role.location },
    { id: "workModel", icon: "briefcase", label: "WORK MODEL", value: role.workModel },
    { id: "employment", icon: "badgeCheck", label: "EMPLOYMENT", value: role.employment },
    { id: "team", icon: "users", label: "TEAM", value: role.teamLabel },
];
